import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from '@shared/services/api.service';
import { DataResponse, SuccessResponse, ListResponse } from '@shared/models/response.model';
import { Cacheable, CacheBuster } from 'ts-cacheable';
import {MeasureTemplate, MeasureTemplateDetails} from '../models/measure-template.model';

const cacheNotifier: Subject<void> = new Subject();
@Injectable({
  providedIn: 'root'
})
export class MeasureTemplateService {

  constructor(private api: ApiService) {}

  @Cacheable({
    cacheBusterObserver: cacheNotifier
  })
  getList(params?: object): Observable<ListResponse<MeasureTemplate>> {
    return this.api.get(`/measure/templates`, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheNotifier
  })
  getListDetail(params?: object): Observable<ListResponse<MeasureTemplateDetails>> {
    return this.api.get(`/measure/template-list`, params);
  }

  getById(id: number): Observable<MeasureTemplate> {
    return this.api.get(`/measure/template/${id}`);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  create(data: object): Observable<DataResponse<MeasureTemplate>> {
    return this.api.post(`/measure/template`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  update(id: number, data: object): Observable<DataResponse<MeasureTemplate>> {
    return this.api.put(`/measure/template/${id}`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  delete(id: number): Observable<SuccessResponse> {
    return this.api.delete(`/measure/template/${id}`);
  }

  static clearCache() {
    cacheNotifier.next();
  }
}
